module.exports = __webpack_public_path__ + "static/img/cz.bef972a0.gif";